import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Title } from "react-admin";
import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  CircularProgress,
  Chip,
} from "@mui/material";
import { API, fetchJson } from "../../api";

interface GameConfig {
  id: string;
  operatorId: string;
  currencyCode: string;
  maxBetsPerUser: number;
  minBet: number;
  maxBet: number;
  maxWinAmount: number;
  hasMoreOptions: boolean;
  rtp: number;
}

export const FdbGameConfigs = () => {
  const [configs, setConfigs] = useState<GameConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    setConfigs([]);
    fetchJson<GameConfig[]>(`${API}/fdb/game-configs`)
      .then((d) => {
        if (d) setConfigs(d);
      })
      .finally(() => setLoading(false));
  }, [location.key]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Title title="FDB Game Configs" />
      <Typography
        sx={{
          fontSize: "1.25rem",
          fontWeight: 700,
          color: "#e2e8f0",
          mb: 3,
          letterSpacing: -0.3,
        }}
      >
        Cached Game Configs
      </Typography>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Operator</TableCell>
            <TableCell>Currency</TableCell>
            <TableCell align="right">Max Bets</TableCell>
            <TableCell align="right">Min Bet</TableCell>
            <TableCell align="right">Max Bet</TableCell>
            <TableCell align="right">Max Win</TableCell>
            <TableCell align="right">RTP</TableCell>
            <TableCell>Options</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {configs.map((c) => (
            <TableRow key={c.id}>
              <TableCell
                sx={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: "0.75rem",
                }}
              >
                {c.id}
              </TableCell>
              <TableCell>{c.operatorId}</TableCell>
              <TableCell>{c.currencyCode}</TableCell>
              <TableCell align="right">{c.maxBetsPerUser}</TableCell>
              <TableCell align="right">{c.minBet}</TableCell>
              <TableCell align="right">{c.maxBet}</TableCell>
              <TableCell align="right">{c.maxWinAmount}</TableCell>
              <TableCell align="right">{c.rtp}</TableCell>
              <TableCell>
                <Chip
                  label={c.hasMoreOptions ? "Yes" : "No"}
                  size="small"
                  color={c.hasMoreOptions ? "info" : "default"}
                  variant="outlined"
                />
              </TableCell>
            </TableRow>
          ))}
          {configs.length === 0 && (
            <TableRow>
              <TableCell colSpan={9} align="center" sx={{ color: "#94a3b8" }}>
                No configs cached
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
};
